import dom from "../../../dist/jsx-render/dom"
import JSXComponent from "../../../dist/jsx-render/JSXComponent"
import { ColumnBase } from "./ColumnBase"
import { Settings } from "./Settings"
import { MsoTable } from "./MsoTable"
import { FilterPopupTreeComponent } from "./FilterPopupTreeComponent"
import { TableColumnTypes } from "./TableColumnTypes"
import { FilterPopupDateTreeComponent } from "./FilterPopupDateTreeComponent"
import { Constants } from "../../Common/constants"

export type FilterPopupComponentProps = {
    column: ColumnBase;
    settings: Settings;
    enableSort: boolean;
    table: MsoTable;
    cell: HTMLElement;
}

export class FilterPopupComponent extends JSXComponent {
    props: FilterPopupComponentProps;
    width = 18; // rem
    height = 21; // rem

    pixelWidth: number;
    pixelHeight: number;

    scalingFactor: number = 1;
    tree: FilterPopupTreeComponent;
    dateTree: FilterPopupDateTreeComponent;

    constructor(props: FilterPopupComponentProps) {
        super(props);
    }

    rowSortAsc: HTMLElement =
        <div className="mt-sort">
            <div className="mt-icon">
                <i className="fal fa-sort-amount-up"></i>
            </div>
            <div className="mt-text">{Resources.Common.sortTypeAsc}</div>
        </div>

    rowSortDesc: HTMLElement =
        <div className="mt-sort">
            <div className="mt-icon">
                <i className="fal fa-sort-amount-down"></i>
            </div>
            <div className="mt-text">{Resources.Common.sortTypeDesc}</div>
        </div>

    rowSearchFilter: HTMLElement =
        <div className="mt-sort" >
            <div className="mt-icon">
                <i className="fal fa-search"></i>
            </div>
            <div style={{ width: "100%"}}>
                <input type="text" placeholder="search" className="mso-view-filter form-control" />
            </div>
        </div>

    rowFilterOff: HTMLElement =
        < div className="mt-sort" >
            <div className="mt-icon">
                <i className="fal fa-ban"></i>
            </div>
            <div className="mt-text">{Resources.Common.removeFilter}</div>
        </div>

    rowSortOff: HTMLElement =
        < div className="mt-sort" >
            <div className="mt-icon">
                <i className="fal fa-ban"></i>
            </div>
            <div className="mt-text">{Resources.Common.removeSort}</div>
        </div>


    buttonOk: HTMLElement =
        <div className="mt-btn">{Resources.Common.ok}</div>

    buttonCancel: HTMLElement =
        <div className="mt-btn">{Resources.Common.cancel}</div>

    renderTree(): HTMLElement {
        if (this.props.column.type != TableColumnTypes.Date) {
            this.tree = new FilterPopupTreeComponent({ table: this.props.table, column: this.props.column });
            let renderedElement = this.tree.render();
            renderedElement.style.overflow = 'visible'
            return renderedElement;
        }
        else {
            this.dateTree = new FilterPopupDateTreeComponent({ table: this.props.table, column: this.props.column });
            let renderedDateElement = this.dateTree.render();
            renderedDateElement.style.overflow = 'visible'
            return renderedDateElement;
        }
    }

    element: HTMLElement;
    getElement = () => {
        var el = document.body;
        var style = window.getComputedStyle(el, null).getPropertyValue('font-size');
        var baseFontSize = parseFloat(style); 

        console.log("BaseFontSize: " + baseFontSize);

        this.pixelWidth = Math.round(this.width * baseFontSize);
        this.pixelHeight = Math.round(this.height * baseFontSize);

        console.log("Pixel width and height: " + this.pixelWidth + ", " + this.pixelHeight);

        //this.element = <div className="mt-filter-popup" style={{ position: "absolute", width: Math.round(this.width * this.scalingFactor).toString() + "px", height: Math.round(this.height * this.scalingFactor).toString() + "px" }}>
        this.element = <div id="filter-popup" className="mt-filter-popup" style={{ position: "absolute", width: this.pixelWidth + "px", height: "auto" }}>
            <div className="sort-box">
                {this.rowSortOff}
                <div className="mt-divider"></div>
                {this.rowSortAsc}
                {this.rowSortDesc}
            </div>
            <div className="filter-box">
                {this.rowFilterOff}
                <div className="mt-divider"></div>
                {this.rowSearchFilter}
            </div>
            <div className="available-items overflow-auto">
                {this.renderTree()}
            </div>
            <div className="mt-buttons">
                {this.buttonOk}
                {this.buttonCancel}
            </div>
        </div>
    }

    render() {
        this.getElement();

        const cellRect = this.props.cell.getBoundingClientRect();
        let left = cellRect.right - this.pixelWidth;
        if (left < 0) {
            left = 0;
        }
        this.element.style.left = cellRect.left.toString() + "px";
        this.element.style.top = cellRect.top.toString() + "px";

        document.body.appendChild(this.element);
        //this.props.cell.appendChild(this.element);


        let renderedElement = document.getElementById("filter-popup") as HTMLElement;

        //calculate the offset of the rendered element in order to position it correctly
        let renderedRect = renderedElement.getBoundingClientRect();
        let renderedOffsetY = renderedRect.top - cellRect.top;
        this.element.style.top = (cellRect.bottom - renderedOffsetY).toString() + "px"; 
        let renderedOffsetX = renderedRect.left - cellRect.left;
        this.element.style.left = (cellRect.left - renderedOffsetX).toString() + "px"; 

        let postOffsetRenderedRect = renderedElement.getBoundingClientRect();
        if ((cellRect.top > renderedElement.offsetHeight) && ((cellRect.bottom + renderedElement.offsetHeight) > window.innerHeight)) {
            // if there is no room to show the popup under the cell and it is enough space above, show it above.
            this.element.style.top = (cellRect.top - renderedElement.offsetHeight - renderedOffsetY).toString() + "px";
        }

        if (postOffsetRenderedRect.right > window.innerWidth) {
            // if there is no room to show the popup to the right, move it to the left.
            this.element.style.left = (window.innerWidth - renderedElement.offsetWidth - renderedOffsetX - 40).toString() + "px";
        }
    }

    public create() {
        // render element
        this.render();
       
        //this.props.cell.closest(".mt-header-row")?.appendChild(this.render());

        // hide popup on click outside
        document.addEventListener("click", this.onDocumentClick);

        // sort handler
        this.rowSortAsc.addEventListener("click", this.onSortAsc);
        this.rowSortDesc.addEventListener("click", this.onSortDesc);

        // buttons
        this.buttonCancel.addEventListener("click", this.onCancelClick);
        this.buttonOk.addEventListener("click", this.onOkClick);

        this.rowFilterOff.addEventListener("click", this.onFilterOff);
        this.rowSortOff.addEventListener("click", this.onSortOff);

        // search filter
        let filterTextbox = this.element.querySelector(".mso-view-filter") as HTMLInputElement;
        if (filterTextbox) {
            filterTextbox.addEventListener('keyup', this.filterView)
        }
    }

    private filterView = (event: Event) => {
        let searchTerm = (event.target as HTMLInputElement).value?.toLocaleLowerCase();

        if (this.props.column.type != TableColumnTypes.Date) {
            if (searchTerm && searchTerm.length > 0) {
                for (let row of this.tree.rows) {
                    var value = row.lastChild?.lastChild?.nodeValue?.toLocaleLowerCase();
                    if (value && value.indexOf(searchTerm) > -1) {
                        row.classList.remove(Constants.cssClass_hidden);
                        this.updateStateRowItem(row, true);
                    } else {
                        row.classList.add(Constants.cssClass_hidden);
                        this.updateStateRowItem(row, false);
                    }
                }
            }
            else {
                this.tree.rows.forEach(e => {
                    e.classList.remove(Constants.cssClass_hidden);
                    this.updateStateRowItem(e, true);
                });
            }
        } else {
            this.dateTree.filterTree(searchTerm);
        }
    }

    updateStateRowItem(row: HTMLElement, value: boolean) {
        (row.firstChild as HTMLInputElement).checked = value;
        this.tree.updateAllCheckBoxes();
    }


    onDocumentClick = (ev: MouseEvent) => {
        let targetElement = ev.target as Node;
        while (targetElement) {
            if (targetElement == this.element || targetElement == this.props.cell) {
                return;
            }
            targetElement = targetElement.parentNode;
        }
        this.dispose();
    }

    onSortAsc = () => {
        this.dispose();
        this.props.table.sortColumnClicked(this.props.column.field, true);
    }

    onSortDesc = () => {
        this.dispose();
        this.props.table.sortColumnClicked(this.props.column.field, false);
    }

    onCancelClick = () => {
        this.dispose();
    }

    onOkClick = () => {
        if ((this.tree && this.tree.checkboxList[0].inputElement.checked) || (this.dateTree && this.dateTree.checkBoxList[0] == "@all@")) {
            this.onFilterOff();
        }
        else {
            let hasItems = false;
            this.props.column.filteredItems = {};
            if (this.tree) {
                for (let i = 1; i < this.tree.checkboxList.length; i++) {
                    if (this.tree.checkboxList[i].inputElement.checked) {
                        this.props.column.filteredItems[this.tree.checkboxList[i].props.value.trim()] = 1;
                        hasItems = true;
                    }
                }
            }
            if (this.dateTree) {
                for (let i = 0; i < this.dateTree.checkBoxList.length; i++) {
                    this.props.column.filteredItems[this.dateTree.checkBoxList[i].trim()] = 1;
                    hasItems = true;
                }
            }
            if (hasItems) {
                this.props.table.fireChangeColumnFilter(this.props.column.field, true);
                this.props.table.filter();
                this.dispose();
            }
            else {
                this.onFilterOff();
            }
        }
    }


    onFilterOff = () => {
        this.props.column.filteredItems = undefined;
        this.props.table.fireChangeColumnFilter(this.props.column.field, false);
        this.props.table.filter();
        this.dispose();
    }

    onSortOff = () => {
        this.props.table.sortColumnClicked(this.props.column.field, false, true);
        this.dispose();
    }

    dispose() {
        document.removeEventListener("click", this.onDocumentClick);
        this.rowSortAsc.removeEventListener("click", this.onSortAsc);
        this.rowSortDesc.removeEventListener("click", this.onSortDesc);
        this.element.parentElement?.removeChild(this.element);
        this.buttonCancel.removeEventListener("click", this.onCancelClick);
    }
}